import onModuleSwitcherItemClick from './onModuleSwitcherItemClick';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { MODULE_CLICKED } from 'mini-host-bridge/lib/nativeMessageConstants';
import { registerScenarioDataListener } from 'mini-host-bridge/lib/utils/scenarioUpdateHandlers';

let onActiveModuleClickAction: () => void;
let onModuleClick: () => void;
let isListenerRegistered = false;

/**
 * This function serves two roles,
 *   1. The first time this function is called, it registers a listener for
 *      the `MODULE_CLICKED` OPX message, which calls `onModuleSwitcherItemClick`
 *      to trigger a module switch.
 *   2. It sets up the callback to execute when the active module's button is
 *      clicked again in the module switcher.
 *
 * @param refreshCallback Callback to execute when active module is clicked again.
 */
export function registerListenerForModuleClicked(refreshCallback?: () => void) {
    // First time register the listener.
    if (!isListenerRegistered) {
        registerScenarioDataListener(({ type, message }) => {
            if (type === MODULE_CLICKED) {
                onModuleSwitcherItemClick(
                    getCurrentModule(),
                    message /* selectedModule */,
                    onActiveModuleClickAction,
                    onModuleClick
                );
            }
        });
        isListenerRegistered = true;
    }
    onActiveModuleClickAction = refreshCallback;
}
